import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { FallbackProps } from "react-error-boundary"
import { useHistory } from "react-router-dom"
import {
	Body,
	Button,
	ButtonGroup,
	Display,
} from "@walmart-web/livingdesign-components"
import { HOME } from "constants/paths"
import unexpectedErrorImage from "assets/images/error/unexpected_error.svg"
import "./index.scss"
import { EMAIL_SUPPORT_CL } from "../../constants/contact"
import { getMailTo } from "../../helpers/contact"

const subject = "Report Issue - Walmart Connect"
const lineBreak = "%0D%0A"
const space = "%20"

const UnexpectedError: React.FC<FallbackProps> = ({
	error,
	resetErrorBoundary,
}) => {
	const history = useHistory()
	const intl = useIntl()
	const body = intl.formatMessage(
		{ id: "phronesis.error.report.body" },
		{
			space,
			lineBreak,
			name: error.name,
			message: error.message,
			stack: error.stack,
		}
	)

	const onReset = () => {
		resetErrorBoundary()
		history.push(HOME)
	}

	return (
		<div className="unexpected-error-container">
			<div className="error-image-container">
				<img alt="Error image" src={unexpectedErrorImage} />
			</div>
			<div>
				<Display variant="2">
					<FormattedMessage id="phronesis.error.title" />
				</Display>
				<Body as="p">
					<FormattedMessage id="phronesis.error.message" />
				</Body>
			</div>
			<div className="error-buttons-sector">
				<ButtonGroup>
					<Button variant="secondary" onClick={onReset}>
						<FormattedMessage id="phronesis.error.back.to.home" />
					</Button>
					<Button
						variant="primary"
						onClick={() => {
							getMailTo(EMAIL_SUPPORT_CL, subject, body)
						}}
					>
						<FormattedMessage id="phronesis.error.report.issue" />
					</Button>
				</ButtonGroup>
			</div>
		</div>
	)
}

export default UnexpectedError
